export function stripLeadingTitle(reportContent: string, title: string): string {
  const normalizedTitle = title.trim();
  if (!normalizedTitle) {
    return reportContent;
  }

  const lines = reportContent.split('\n');
  const firstNonEmptyIndex = lines.findIndex((line) => line.trim().length > 0);
  if (firstNonEmptyIndex === -1) {
    return reportContent;
  }

  const firstLine = lines[firstNonEmptyIndex].trim();
  const headingText = firstLine.replace(/^#{1,6}\s+/, '').trim();
  if (headingText !== normalizedTitle) {
    return reportContent;
  }

  lines.splice(firstNonEmptyIndex, 1);
  while (firstNonEmptyIndex < lines.length && lines[firstNonEmptyIndex] === '') {
    lines.splice(firstNonEmptyIndex, 1);
  }
  return lines.join('\n');
}

export function getPublicDeepResearchPreviewRef<T>(
  references: readonly T[],
  index: number,
): T | null {
  return references[index] ?? null;
}
